(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blog-caterory-by-tags"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('select.bc-select').forEach(select => {
        select.addEventListener('change', function(){
        const url = select.value;
            window.location.href = url;
        });
    });
  } catch(e) { console.error(e); }
})();

})();
